import { render, staticRenderFns } from "./Terreno.vue?vue&type=template&id=30d97dd0&scoped=true&lang=html&"
import script from "./Terreno.vue?vue&type=script&lang=js&"
export * from "./Terreno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d97dd0",
  null
  
)

export default component.exports